// Approved cities for agent profile + Find-Agent
export const CITIES = [
  "Bengaluru",
  "Mumbai",
  "Delhi",
  "Hyderabad",
  "Chennai",
  "Pune",
  "Kolkata",
  "Ahmedabad",
  "Surat",
  "Jaipur",
  "Kochi",
  "Chandigarh",
  "Nagpur",
  "Indore",
  "Lucknow",
  "Noida",
  "Gurgaon",
  "Vizag",
  "Coimbatore",
  "Mysuru",
  "Banglore",
];
